"use strict";

require("core-js/modules/es.promise");

module.exports = arr => (arr.forEach(a => a.value instanceof Promise && a.value.catch(function () {})), arr);